import React, { useEffect } from "react";
import { Form, Input, Switch, Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PaymentMethodFormModal = ({ onCancel, initialData, isEdit, onSubmit, loading }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (initialData && isEdit) form.setFieldsValue(initialData);
    else {
      form.resetFields();
      form.setFieldsValue({ paymentMethodIsActive: true });
    }
  }, [initialData, isEdit, form]);

  const handleFinish = (values) => {
    const formatted = { ...values, paymentMethodIsActive: values.paymentMethodIsActive ?? true };
    onSubmit(formatted);
    onCancel();
  };

  return (
    <div className="card table-list-card">
      <div
        className="d-flex align-items-center justify-content-between px-4 py-3"
        style={{ background: 'var(--primary-gradient)', borderRadius: "8px 8px 0 0" }}
      >
        <h4 className="text-white mb-0">   {isEdit ? t("paymentMethods.edit") : t("paymentMethods.addTitle")}</h4>
        <div className="d-flex gap-2">
          <Button onClick={onCancel}>{t("common.cancel")}</Button>
          <Button loading={loading} type="primary" onClick={() => form.submit()}>
            {isEdit ? t("common.save") : t("common.add")}
          </Button>
        </div>
      </div>

      <div className="card-body p-4">
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Form.Item name="paymentMethodName"  label={t("paymentMethods.name")} rules={[{ required: true,  message: t("paymentMethods.requiredName")  }]}>
             <Input placeholder={t("paymentMethods.exampleName")} />
          </Form.Item>
          <Form.Item name="paymentMethodDescription"   label={t("paymentMethods.description")}>
            <Input.TextArea rows={3} placeholder={t("paymentMethods.exampleDescription")} />
          </Form.Item>
          <Form.Item name="paymentMethodIsActive"  label={t("paymentMethods.status")} valuePropName="checked">
            <Switch defaultChecked />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

PaymentMethodFormModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  isEdit: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default PaymentMethodFormModal;